import _Person from "@mui/icons-material/Person";
var _templateObject;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
import React, { forwardRef, useMemo } from 'react';
import { COLORS, Image, ImageEntity } from '@fupa/fupa-uikit';
import styled from 'styled-components';
const AvatarContainer = styled.div.withConfig({
  componentId: "sc-wrclm5-0"
})(["box-sizing:content-box;display:flex;overflow:hidden;justify-content:center;align-items:center;width:", ";height:", ";border-radius:50%;border:", ";background-color:", ";", ""], props => props.dim, props => props.dim, props => props.active ? "2px solid ".concat(COLORS.fupaSecondary) : "2px solid ".concat(COLORS.white), COLORS.grey, props => props.theme.desktopLayout(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    border: ", ";\n  "])), props.active ? "2px solid ".concat(COLORS.fupaSecondary) : "2px solid ".concat(COLORS.white)));
export const LoadingSkeleton = styled.div.withConfig({
  componentId: "sc-wrclm5-1"
})(["width:100%;height:100%;background:", ";background:linear-gradient(110deg,", " 15%,", " 50%,", " 85%);border-radius:50%;background-size:200% 100%;animation:1.5s shine linear infinite;@keyframes shine{to{background-position-x:-200%;}}"], COLORS.lightGrey, COLORS.lightestGrey, COLORS.lightGrey, COLORS.lightestGrey);
const StyledPersonIcon = styled(_Person).withConfig({
  componentId: "sc-wrclm5-2"
})(["margin:auto;"]);
const Avatar = /*#__PURE__*/forwardRef((_ref, ref) => {
  var _props$alt;
  let {
    width,
    src,
    active,
    loading,
    ...props
  } = _ref;
  const dim = width / 16 + 'rem';
  const imageSrc = useMemo(() => {
    if (src) {
      const pathArray = src.split('/');
      pathArray.pop();
      const path = pathArray.join('/');
      return {
        path: path + '/',
        description: null,
        source: null,
        svg: false
      };
    }
    return {
      path: '',
      description: null,
      source: null,
      svg: false
    };
  }, [src]);
  const avatar = src ? /*#__PURE__*/React.createElement(Image, {
    entity: ImageEntity.User,
    height: width,
    width: width,
    src: imageSrc,
    alt: (_props$alt = props.alt) !== null && _props$alt !== void 0 ? _props$alt : 'Nutzeroptionen öffnen',
    ratio: '1:1',
    circle: true
  }) : loading ? /*#__PURE__*/React.createElement(LoadingSkeleton, null) : /*#__PURE__*/React.createElement(StyledPersonIcon, {
    color: "icon"
  });
  return /*#__PURE__*/React.createElement(AvatarContainer, _extends({
    ref: ref
  }, props, {
    active: active,
    dim: dim
  }), avatar);
});
export { Avatar };